<template>
  <div class="content-box">
    <img src="~imgM/index_bg.jpg" width="100%" alt="" class="bg_img">
    <div class="content" ref="sy">
      <div class="head_nav">
        <img :src="getPic('logo','png')" alt="" class="logo">
        <div class="nav-right" ref="navList">
          <div class="nav-btn-outer" @click.stop="navChange">
            <div class="nav-btn">
              <div class="nav-btn-inner"></div>
            </div>
          </div>
          <div v-if="navFlag" class="nav-list">
            <div class="nav" v-for="(item, index) in navs" :class="[`nav_${index}`,{'nav_focus': index === navFocusFlag}]"
                 @mouseenter.stop="navFocus(index)" @mouseleave.stop="navFocus(-1)" @click.stop="scrollDom(index)">
              {{item}}
            </div>
          </div>
        </div>
      </div>
      <div class="gsjj" ref="nav1"></div>
      <div class="tdjs" ref="nav2"></div>
      <div class="gscp" ref="nav3"></div>
      <div class="wmdys" ref="nav4"></div>
      <div class="wmdmb" ref="nav5"></div>
      <div class="product">
        <img src="~imgM/wjfz_icon.png" width="100%" alt="" class="product_img"
             @click.stop="openOthers('prod')">
        <img src="~img/wjfz_word.png" width="100%" alt="" class="product_word"
             @click.stop="openOthers('prod')">
      </div>
      <div class="box-bottom">
        <div v-for="(item, index) in bottomLink" :class="`url${index+1}`" @click.stop="openOthers(item)">
          {{ item.name }}
        </div>
        <div class="beian0">
          <a href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank"></a>
        </div>
        <div class="beian">
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=51019002007896" rel="noreferrer" target="_blank">川公网安备51019002007896号</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Mhome',
  data() {
    return {
      navs: [
        "首页", "公司简介", "团队介绍", "公司产品",  "我们的优势", "我们的目标"
      ],
      navFocusFlag: -1,
      navFlag: false,
      bottomLink: [
        {
          "name": "隐私协议",
          "router": "ysxy",
          "link": "https://fanyukaitian.com.cn/yhxy"
        },
        {
          "name": "用户协议",
          "router": "ysxy",
          "link": "https://fanyukaitian.com.cn/yhxy"
        }
      ]
    }
  },
  created() {
  },
  mounted() {
  },
  watch: {
  },
  methods: {
    //底部跳转链接
    openOthers(item) {
      if (item=== 'prod') {
        window.open('https://fanyukaitian.com.cn/wj/', '_blank');
      } else {
        //window.open(item.link, '_blank');
        this.$router.push({
          name: item.router
        }).catch(() => {});
      }
    },
    openUserTerm() {
      window.open(this.outLink.userTerm, '_blank');
    },
    openPrivacyTerm() {
      window.open(this.outLink.privacyTerm, '_blank');
    },
    navChange() {
      this.navFlag = !this.navFlag;
    },
    getPic(pic, type) {
      return require(`img/${pic}.${type}`);
    },
    navFocus(index) {
      this.navFocusFlag = index;
    },
    scrollDom(ref) {
      this.$refs[`nav${ref}`].scrollIntoView();
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "~styles/index.less";

.content-box {
  width: 7.5rem;

  .content {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 70.5rem;
    z-index: 1;

    .head_nav {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: .85rem;
      z-index: 1000;

      .logo{
        float: left;
        margin: .04rem 0 0 .26rem;
        width: 1.4rem;
        height: auto;
      }

      .nav-right{
        position: absolute;
        right: 0;
        top: 0;
        width: 1.67rem;
        height: .82rem;

        .nav-btn-outer {
          box-sizing: border-box;
          width: 1.97rem;
          height: .58rem;
          text-align: right;
          padding-top: .21rem;

          .nav-btn {
            margin-right: .64rem;
            display: inline-block;
            width: .31rem;
            height: .22rem;
            border-top: .03rem solid rgba(215, 98, 9, 1);
            border-bottom: .03rem solid rgba(215, 98, 9, 1);

            .nav-btn-inner {
              width: 100%;
              height: .1rem;
              border-bottom: .03rem solid rgba(215, 98, 9, 1);
            }
          }
        }

        .nav-list {
          box-sizing: border-box;
          padding-top: .06rem;
          width: 1.67rem;
          height: 2.89rem;
          background: rgba(145, 134, 134, 1);

          .nav {
            width: 100%;
            height: 0.46rem;
            cursor: pointer;
            font-family: STZhongsong;
            font-weight: 400;
            font-size: 0.24rem;
            color: rgba(255, 255, 255, 1);
            line-height: 0.46rem;

            &.nav_focus::before {
              color: rgba(255, 114, 0, 1);
            }
          }
        }
      }
    }
    .gsjj{
      position: absolute;
      top: 11rem;
      width: 100%;
    }
    .tdjs{
      position: absolute;
      top: 23rem;
      width: 100%;
    }
    .gscp{
      position: absolute;
      top: 30.4rem;
      width: 100%;
    }
    .wmdys{
      position: absolute;
      top: 48rem;
      width: 100%;
    }
    .wmdmb{
      position: absolute;
      top: 70rem;
      width: 100%;
    }
    .product{
      position: absolute;
      width: 100%;
      left: 0.18rem;
      top: 32rem;
      cursor: pointer;
      display: flex;
      align-items: center;

      .product_img{
        width: 3.86rem;
      }

      .product_word{
        width: 2.6rem;
        height: 100%;
      }
    }
    .box-bottom{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      .url1 {
        position: absolute;
        bottom: 2.2rem;
        left: .5rem;
        cursor: pointer;
        font-family: FZYaSongS-B-GB;
        font-weight: 400;
        font-size: 0.2rem;
        color: rgba(221, 140, 75, 1);
      }

      .url2 {
        position: absolute;
        bottom: 2.2rem;
        left: 1.7rem;
        cursor: pointer;
        font-family: FZYaSongS-B-GB;
        font-weight: 400;
        font-size: 0.2rem;
        color: rgba(221, 140, 75, 1);
      }
      .beian0{
        position: absolute;
        bottom: 1.1rem;
        left: .4rem;
        width: 4rem;
        height: .2rem;
        line-height: .2rem;
        cursor: pointer;
        a{
          display: inline-block;
          margin-left: .1rem;
          width: 100%;
          height: 100%;
        }
      }
      .beian{
        position: absolute;
        bottom: .78rem;
        left: .5rem;
        width: 3.6rem;
        height: .2rem;
        line-height: .2rem;
        cursor: pointer;
        a{
          display: inline-block;
          margin-left: .1rem;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/mhome.vue